module.exports = __webpack_public_path__ + "static/media/hitpaw-toolkit-box.c0bd643f.png";